<template>
  <div class="content">
    <div class="container">
      <h1 class="mb-5">
        Pricing Table
      </h1>
      <card-box>
        <p>
          Please use this table to reference our current product offerings <br>
          Additional Charges (Per Unit, Apparel Only): <br>
          Size 2XL to 5XL: 3.00$
          <br>
          2-Sided Print: 5.00$
          <br>
          Commission Rates: 10% Artist
        </p>

        <table class="table table-striped w-100 d-block d-md-table table-sm">
          <thead class="text-uppercase">
            <tr>
              <th />
              <th class="text-center" />
              <th
                colspan="2"
                class="text-center text-uppercase"
              >
                Shipping US
              </th>
              <th
                colspan="2"
                class="text-center text-uppercase"
              >
                Shipping Worldwide
              </th>
            </tr>
            <tr>
              <th>Name</th>
              <th class="text-center">
                Base cost
              </th>
              <th class="text-center">
                First Item
              </th>
              <th class="text-center">
                Additional
              </th>
              <th class="text-center">
                First Item
              </th>
              <th class="text-center">
                Additional
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in tables"
              :key="item.id"
            >
              <td>{{ item.name }}</td>
              <td class="text-center">
                {{ item.base_cost || 0 }}
              </td>
              <td class="text-center">
                {{ item.shipping || 0 }}
              </td>
              <td class="text-center">
                {{ item.shipping_addon || 0 }}
              </td>
              <td class="text-center">
                {{ item.shipping_global || 0 }}
              </td>
              <td class="text-center">
                {{ item.shipping_global_addon || 0 }}
              </td>
            </tr>
          </tbody>
        </table>
      </card-box>
    </div>
  </div>
</template>

<script>
    import CardBox from "@/components/CardBox";
    import CardTitle from "@/components/CardTitle";

    export default {
        name: "PriceTable",
        components: {CardTitle, CardBox},
        data: function () {
            return {
                tables: []
            }
        },
        mounted: function () {
            this.load()
        },
        methods: {
            load: function () {
                let vm = this
                this.$http.get(this.$config.api + 'price-table').then(function (res) {
                    vm.tables = res.data
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    table {
        thead {
            td {
                border-top: 0;
            }
        }
    }
</style>